const rankingItems = [
  { rank: 1, title: '51cg最新官方域名入口汇总', heat: '本周访问最多', tag: '域名' },
  { rank: 2, title: '51cg.fun域名状态实时确认', heat: '持续关注中', tag: '域名' },
  { rank: 3, title: '51cg平台功能全解析指南', heat: '新用户必读', tag: '教程' },
  { rank: 4, title: '仿冒51cg站点识别方法', heat: '安全关注度高', tag: '安全' },
  { rank: 5, title: '51cg移动端访问体验报告', heat: '移动用户热读', tag: '体验' },
  { rank: 6, title: '51cg社区热门话题一周回顾', heat: '社区讨论活跃', tag: '社区' },
];

function RankBadge({ rank }: { rank: number }) {
  if (rank === 1) return <span className="w-7 h-7 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center text-xs font-bold flex-shrink-0">1</span>;
  if (rank === 2) return <span className="w-7 h-7 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-xs font-bold flex-shrink-0">2</span>;
  if (rank === 3) return <span className="w-7 h-7 rounded-lg bg-secondary-500 text-background-50 flex items-center justify-center text-xs font-bold flex-shrink-0">3</span>;
  return <span className="w-7 h-7 rounded-lg bg-background-200 text-foreground-500 flex items-center justify-center text-xs font-bold flex-shrink-0">{rank}</span>;
}

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热门排行</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">近期最受关注的51cg相关内容排行</p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
            {rankingItems.map((item, i) => (
              <a
                key={i}
                href={item.tag === '域名' ? '#updates' : item.tag === '安全' ? '#faq' : '#cards'}
                className={`flex items-center gap-4 px-5 md:px-6 py-4 hover:bg-background-100 transition-colors duration-150 cursor-pointer no-underline ${
                  i < rankingItems.length - 1 ? 'border-b border-background-200/60' : ''
                }`}
              >
                <RankBadge rank={item.rank} />
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-bold text-foreground-900 truncate">{item.title}</h3>
                  <p className="text-xs text-foreground-400 mt-0.5">{item.heat}</p>
                </div>
                <span className="text-[10px] px-2 py-1 rounded-full bg-primary-50 text-primary-600 font-medium whitespace-nowrap flex-shrink-0">
                  {item.tag}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}